import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';

//import components
import ItemText from './ItemText.js';

// img
import fieldRed from '../../assets/icons/field-red.svg';
import fieldGreen from '../../assets/icons/field-green.svg';
import fieldYellow from '../../assets/icons/field-yellow.svg';
import fieldViolet from '../../assets/icons/field-violet.svg';

const ItemNested = ({ clang, list, type, domain }) => {

    const getImgField = () => {
        let imgType;

        switch (domain.label) {
          case 'polish-literature':
              imgType = fieldRed;
              break;
          case 'literature-theory':
              imgType = fieldViolet;
              break;
          case 'foreign-literature':
              imgType = fieldGreen;
              break;
          case 'movie-theatre-rtv':
              imgType = fieldYellow;
              break;
          default:
              break;
        }

        return <img src={imgType} alt="" className="item__nested__field-img"/>;
    };

    return (
        <div className="item__nested-container">
            <div className="item__nested__field">
                {getImgField()}
                <ItemText text={`${lang[clang].results.field}:`}/>
                <ItemText text={lang[clang].field_types[domain.label] ? lang[clang].field_types[domain.label] : domain.label} link={domain.link}/>
            </div>
            <div className="item__nested__section">
                <ItemText text={`${lang[clang].results[type]}:`}/>
                {list.map((listItem, index) =>
                    <div key={listItem.id} className="item__nested">
                        <ItemText text={lang[clang].field_types[listItem.label] ? lang[clang].field_types[listItem.label] : listItem.label} link={listItem.link}/>
                        {index !== list.length - 1 && <span className="item__nested-icon">{decodeURI('%3E')}</span>}
                    </div>)}
            </div>
        </div>
    );
};

ItemNested.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemNested);



// WEBPACK FOOTER //
// ./src/components/items/ItemNested.js